import _ from '@app/utils.js'

const isBoldParagraph = el => {
  if (el.tagName !== 'P') return false
  const first = el.firstChild
  const strong = first && first.nodeType === Node.ELEMENT_NODE && ['STRONG', 'B'].includes(first.tagName)
  return Boolean(strong) && first.textContent.trim() !== ''
}

// Il testo dei contatti arriva da un editor WYSIWYG: ogni paragrafo che inizia in
// grassetto apre una sezione, che comprende i paragrafi successivi fino al
// prossimo grassetto. Le sezioni vengono distribuite con space-between.
_.onElementReady('.page-node-type-contacts .main-content .row > [class*="col-"]', col => {
  if (col.dataset.contactsSections) return
  // I paragrafi vuoti (&nbsp;) servono solo come distanziatori: la separazione
  // è affidata allo space-between.
  ;[...col.children].forEach(el => {
    if (el.tagName === 'P' && el.textContent.replace(/\u00a0/g, '').trim() === '') el.remove()
  })
  const children = [...col.children]
  if (!children.some(isBoldParagraph)) return
  col.dataset.contactsSections = '1'

  let section = null
  children.forEach(child => {
    if (!section || isBoldParagraph(child)) {
      section = document.createElement('div')
      section.className = 'contacts-section'
      col.insertBefore(section, child)
    }
    section.appendChild(child)
  })
  col.classList.add('contacts-sections')
})
